import { pageStateType } from "types";


export const SET_PAGE_STATE = (payload: pageStateType) => ({
    type: 'SET_PAGE_STATE',
    payload: payload
  });  
